exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pdf-content .centered-pdf-page {\n  display: flex;\n  justify-content: center;\n  position: relative;\n}\n", ""]);

// exports
